import { kHorzBoxSpacing, kVertBoxSpacing } from "../constants";

export function GetDefaultManualSpacing() {
  var defaultVals = [];
  defaultVals.push(kHorzBoxSpacing); // left margin
  defaultVals.push(kVertBoxSpacing); // top margin
  defaultVals.push(kHorzBoxSpacing); // right margin
  defaultVals.push(kVertBoxSpacing); // bottom margin
  defaultVals.push(kVertBoxSpacing); // managerv spacing1
  defaultVals.push(kVertBoxSpacing); // managerv spacing2
  defaultVals.push(0); // spacing left,top,right, bottom
  defaultVals.push(0);
  defaultVals.push(0);
  defaultVals.push(0);

  return defaultVals;
}
